const download_app = {
  enjoy_a_better_mobile:
    'Profitez d’une meilleure expérience sur mobile en téléchargeant l’application !',
  scan_to_upload_to: 'Scanner pour télécharger sur',
  available_on_playStore: 'Disponible sur PlayStore',
  available_on_appStore: 'Disponible sur AppStore',
}

export default download_app
